/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/structural_template/canvas_template_territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateTerritories } from "./constants";
import type {
  CanvasTemplateTerritoriesParams,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateTerritoriesResult,
} from "./types";

export const getEngagementAppGroupIdStructuralTemplateCanvasTemplateTerritories = reactQueryFetcherAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateTerritories,
  (
    signal: AbortSignal,
    { appGroupId }: CanvasTemplateTerritoriesParams
  ): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateTerritoriesResult> => {
    return fetch(
      `/engagement/${appGroupId}/structural_template/canvas_template_territories`,
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  }
);
